<script setup>
import {
  computed,
  onBeforeUnmount,
  onMounted,
  onErrorCaptured,
  ref,
} from 'vue';
import AiRodiziosPage from '../../ia-rodizios/Index.vue';

const props = defineProps({
  team: { type: Object, required: true },
});
const emit = defineEmits(['close']);
const childError = ref(null);

onErrorCaptured(error => {
  childError.value = error?.message || String(error);
  // eslint-disable-next-line no-console
  console.error('[AceleresTeamIaModal] falha ao montar IA e Rodízios:', error);
  return false;
});

const modalText = {
  title: 'IA e Rodízios',
  description:
    'Configurações de IA e distribuição (rodízio) exclusivas desta equipe.',
};

const modalTitle = computed(() =>
  props.team ? `${modalText.title} - ${props.team.name || ''}` : modalText.title
);

const close = () => emit('close');

const onEsc = event => {
  if (event.key === 'Escape') {
    close();
  }
};

onMounted(() => document.addEventListener('keydown', onEsc));
onBeforeUnmount(() => document.removeEventListener('keydown', onEsc));
</script>

<template>
  <Teleport to="body">
    <div
      class="teams-page__ia-modal-backdrop fixed inset-0 z-[9999] flex items-center justify-center bg-[rgba(15,23,42,0.55)] p-4"
    >
      <div
        class="teams-page__ia-modal flex max-h-[calc(100vh-2rem)] w-full max-w-5xl min-w-0 flex-col overflow-hidden rounded-[12px] border border-n-weak bg-white shadow-[0_12px_40px_rgba(15,23,42,0.12)]"
        role="dialog"
        aria-modal="true"
        :aria-label="modalTitle"
        @click.stop
      >
        <header
          class="teams-page__ia-modal-header flex flex-shrink-0 items-start justify-between gap-4 border-b border-n-weak px-6 py-5"
        >
          <div class="min-w-0">
            <h2
              class="teams-page__ia-modal-title m-0 truncate text-xl font-semibold text-n-slate-12"
            >
              {{ modalTitle }}
            </h2>
            <p
              class="teams-page__ia-modal-description mb-0 mt-2 text-sm leading-6 text-n-slate-11"
            >
              {{ modalText.description }}
            </p>
          </div>
          <button
            type="button"
            class="teams-page__ia-modal-close inline-flex size-9 items-center justify-center rounded-full border border-n-weak bg-white text-n-slate-11 transition-colors hover:bg-n-slate-2 hover:text-n-slate-12"
            @click="close"
          >
            <span class="i-lucide-x size-4" />
          </button>
        </header>

        <div
          class="teams-page__ia-modal-body scrollbar-thin mx-2 min-h-0 overflow-y-auto overscroll-contain px-4 pb-6 pt-5"
        >
          <!-- eslint-disable vue/no-bare-strings-in-template -->
          <div
            v-if="childError"
            class="rounded border border-n-ruby-7 bg-n-ruby-2 px-4 py-3 text-sm text-n-ruby-11"
          >
            Não foi possível carregar IA e Rodízios. Feche e tente novamente.
            <span class="ml-1 opacity-70">({{ childError }})</span>
          </div>
          <!-- eslint-enable vue/no-bare-strings-in-template -->
          <AiRodiziosPage v-else :team-id="team.id" />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.teams-page__ia-modal-backdrop {
  isolation: isolate;
}

.teams-page__ia-modal {
  position: relative;
  z-index: 10000;
}

.teams-page__ia-modal-body {
  scrollbar-color: #cbd5e1 transparent;
  scrollbar-width: thin;
}

.teams-page__ia-modal-body::-webkit-scrollbar {
  width: 6px;
}

.teams-page__ia-modal-body::-webkit-scrollbar-track {
  background: transparent;
}

.teams-page__ia-modal-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 999px;
}

.teams-page__ia-modal-body::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>
